import type { NavigationPlaceDescriptor } from '@efficiently/client-core-navigation';
import { SCHEDULES_ROUTES, toRouteParam } from '@efficiently/client-core-routing';

import { SUPPLY_SCHEDULES_HIDDEN_FILTERS } from './constants/supply-schedules-hidden-filters.constant';
import { DESIGN_ITEM_SCHEDULE_ITEM_IDS_NAVIGATION_PLACE } from './design-item-schedule-item-ids.navigation-place';
import { toSupplyItemSchedulePath } from './utils/to-supply-item-schedule-path.util';
import { withoutHiddenFilterKeys } from './utils/without-hidden-filter-keys.util';

/**
 * The Supply Item Schedule Item IDs sub-tab, a place the agent may open: Design Item IDs' keys without
 * the filter keys Supply hides, and Design Item IDs' fly-ins.
 */
export const SUPPLY_ITEM_SCHEDULE_ITEM_IDS_NAVIGATION_PLACE: NavigationPlaceDescriptor = {
	placeKey: 'supply-item-schedule-item-ids',
	path: toSupplyItemSchedulePath(
		SCHEDULES_ROUTES.ITEM_IDS.relativePath(toRouteParam(SCHEDULES_ROUTES.ITEM_IDS.PARAMS.VIEW)),
	),
	keys: withoutHiddenFilterKeys(DESIGN_ITEM_SCHEDULE_ITEM_IDS_NAVIGATION_PLACE.keys, SUPPLY_SCHEDULES_HIDDEN_FILTERS),
	flyIns: DESIGN_ITEM_SCHEDULE_ITEM_IDS_NAVIGATION_PLACE.flyIns,
};
